.container {
  max-width: 400px;
  position: relative;
  margin-bottom: var(--space-m);
}

.aspectRatio {
  width: 100%;
  height: 0;
  position: relative;
}

.dropzone {
  z-index: 1;

  &.hasError {
    outline-color: #aa1729;
  }
}

.error {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #aa1729;
  padding: 8px 0 0;
  display: block;
  text-transform: none;
  text-align: left;
  margin-top: calc(-1 * var(--space-m));
}

.imagePreview {
  padding: var(--space-m);
  position: relative;
  z-index: 2;
}

.container:hover .dropzone {
  z-index: 3;
}

.removeButton {
  width: max-content;
}
